import { useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchBar from "../../components/SearchBar";
import AddCategory from "../../Modals/addCategory";

const CategoryTopbar = () => {

  const [searchTerm, setSearchTerm] = useState("");
  
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </Box>
        </div>
        <div className="right_s">
          <Button className="btn btn_primary" onClick={() => setOpen(true)}><AddIcon /> Add Category</Button>
        </div>
      </div>

      <AddCategory open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default CategoryTopbar;
